<template>
  <div>

<div  class='menu row navbar' :class="{ 'navbar--hidden': !showNavbar }">
  <div class="col-6"><router-link :to="{name:'Home'}" class="logo"> <img :src="`${publicPath}logo-color.svg`" alt="logo nicolas noel"> </router-link></div>
  <div class="hamburger col-6" >
    <i class="fas fa-bars" @click="toggleMenu" ></i>

  </div>
</div>



  <transition name="menuTransition" mode="out-in">
  <div class="menuScreen" v-if="menuOpen">
    <ul>
    <i class="fas fa-times" @click="toggleMenu"></i>
    <li @click="toggleMenu"><router-link :to="{name:'Home'}" >Accueil</router-link></li>
    <li @click="toggleMenu"><router-link :to="{name:'Projets'}" >Mon travail</router-link></li>
    <li @click="toggleMenu"><router-link :to="{name:'Apropos'}" >À propos</router-link></li>
  </ul>
  </div>
</transition>
</div>

</template>

<script>
export default {
  data : function () {
    return{
      menuOpen:false,
      publicPath: process.env.BASE_URL,
            showNavbar: true,
      lastScrollPosition: 0
    }
  },
  // props: {
  //     colorMenu: {
  //     type:Boolean,
  //     default:false
  //     }
  //   },
  methods :{
    toggleMenu : function () {
      this.menuOpen = ! this.menuOpen
    },
    onScroll () {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollPosition < 0) {
        return
      }  // Stop executing this function if the difference between
      // current scroll position and last scroll position is less than some offset
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
        return
      }
      this.showNavbar = currentScrollPosition < this.lastScrollPosition
      this.lastScrollPosition = currentScrollPosition
    }
  },
  mounted () {
  window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  }

}
</script>


<style scoped>
.navbar.navbar--hidden {

  transform: translate3d(0, -200%, 0);
}

.navbar{

transform: translate3d(0, 0, 0);
transition: 0.1s all ease-out;
}

.menu{
  margin-top: 2.5rem;
  font-size: 2rem;
  color: #dec8b2;
  padding: 0 7.5rem 0 7.5rem;
  position: fixed;
  width: 100%;
    z-index: 2000;
    max-height: 100px;
}

i{
  cursor: pointer;
}

.menu i{
    color: #dec8b2;
}

.menu a{
    color: #dec8b2;
}

.logo img{
  max-height: 45px;
max-width: 80px;

}

.hamburger{
  text-align: right;
    z-index: 9999;

}

.hamburger i{
      color: #222;
}

.menuScreen{
  top:0;
  right:0;
  position: fixed;
  background-color: #dec8b2;
  width: 50%;
  height: 100vh;
  z-index: 3000;
  padding: 2.5rem 7.5rem 0 7.5rem;

}

.menuList{
  padding-top: 4rem;

  height: 100%;
    text-align: right;
}

.menuScreen ul{
  width: 100%;
}

.menuScreen li a{
  text-align: right;
  color: #222;
  font-size: 4rem;
  line-height: 6rem;
  font-weight: bold;
  transition: 0.3s;
}

.menuScreen li a:hover{
  transition: 0.3s;
      color: #dec8b2;
        color: #888;
}

.menuScreen i{
  width: 100%;
  text-align: right;
  font-size: 2rem;
        color: #888;
}

.menuTransition-enter-active, .menuTransition-leave-active{
  transition: .5s;

}

.menuTransition-enter, .menuTransition-leave-active{
  opacity:0;
  width:25%;
    padding-right: 0;
    padding-left: 0;
}

@media all and (max-width: 736px) {
.menu{
    padding: 0 4rem 0 4rem;
}

.menuScreen{
    padding: 2.5rem 4rem 0 4rem;
    width: 100%;
}

.menu i{
        color: #dec8b2;
}


}

</style>
